<template>
  <div id="email-coletivo">
      <div v-if="!enviarEmailMassa">
        <div class="col-md-3">
          <a  @click="abrirEnviarEmail" class="btn btn-default btn-block">
            <i class="fa fa-envelope-o" aria-hidden="true"></i>
            Enviar E-Mail Coletivo
          </a>
        </div>
      </div>
      <div v-else="!enviarEmailMassa">
        <div class="col-md-12"><br>
               <div class="panel panel-default">
                  <div class="panel-body">
                      <div class="col-md-10">
                          <h3>Enviar E-Mail em Massa</h3>
                      </div>
                      <div class="col-md-2" v-if="!carregando"><br>
                        <button type="button" class="btn btn-default" @click="enviarEmailMassa = false">
                          <i class="fa fa-times" aria-hidden="true"></i>
                          <span v-if="enviado">Fechar</span>
                          <span v-else>Cancelar Envio</span>
                        </button>
                      </div>
                      <!-- FORMULÁRIO -->
                      <div v-if="!carregando && !enviado">
                          <div class="col-md-12"><br>
                            <div class="form-group">
                                  <input type="checkbox" id="todos" v-model="email.todos">
                                  <label for="todos" :class="classTodos"> Todos Usuários</label> . | .

                                  <input type="checkbox" id="pagantes" v-model="email.pagantes">
                                  <label for="pagantes" :class="classPagantes"> Pagantes </label> . | .

                                  <input type="checkbox" id="solic_plano" v-model="email.solic_plano">
                                  <label for="solic_plano" :class="classSolicitaram"> Solicitaram Plano </label> . | .

                                  <input type="checkbox" id="prox_venc" v-model="email.prox_venc">
                                  <label for="prox_venc" :class="classProxVenc"> Próximos Vencimentos </label> . | .

                                  <input type="checkbox" id="vencidos" v-model="email.vencidos">
                                  <label for="vencidos" :class="classVencidos"> Vencidos </label> . | .

                                  <input type="checkbox" id="gratis" v-model="email.gratis">
                                  <label for="gratis" :class="classGratis"> Gráris </label> . | .

                                  <input type="checkbox" id="nao_tem_pacientes" v-model="email.nao_tem_pacientes">
                                  <label for="nao_tem_pacientes" :class="classNaoTemPac"> Não tem pacientes </label> . | .

                                  <input type="checkbox" id="teste" v-model="email.teste">
                                  <label for="teste" :class="classTeste"> Teste Conteúdo </label>

                                  <div class="text-danger" v-if="mostrarMsgValidar">
                                    Para enviar você deve selecionar pelo menos um fltro acima!
                                  </div>
                            </div>
                          </div>
                          <div class="col-md-12">
                              <div class="form-group">
                                <label for="">Assunto</label>
                                <input type="text" class="form-control" placeholder="Título do E-mail"
                                v-model="email.assunto">
                              </div>
                              <div class="form-group">
                                <label for="">Conteúdo</label>
                                <!-- Editor -->
                                <quill-editor ref="myTextEditor"
                                        v-model="email.corpo_email"
                                        :config="editorOption">
                                </quill-editor>
                              </div>
                          </div>

                          <div class="col-md-7">
                            <p class="text-danger" v-if="confirmar"><br>
                              <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                              Atenção: Confirme novamente o <b>grupo de usuários</b> que
                              receberão este email, certifique-se de que <b> assunto,
                              conteúdo e código</b>, estão corretos.<br><br>
                              <b><i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                Esta operação não poderá ser cancelada. </b>
                            </p>
                          </div>
                          <div class="col-md-1">
                            <label for="">Código<span class="text-danger">*</span></label>
                          </div>
                          <div class="col-md-2">
                            <div class="form-group">
                              <input type="number" class="form-control" v-model="email.cod_id"
                                      placeholder="Código ID">
                            </div>
                          </div>
                          <div class="col-md-2">
                            <button type="button" class="btn btn-primary btn-block"
                                    :disabled="btnEnviar" @click="confirmar = true">
                              <i class="fa fa-envelope" aria-hidden="true"></i>
                              Enviar Email
                            </button>
                            <div v-if="confirmar" class="text-center"><br>
                              <p class="text-danger">
                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                Confirmar Envio?</p>
                              <button type="button" class="btn btn-danger" @click="enviarEmail">
                                SIM
                              </button>
                              <button type="button" class="btn btn-default" @click="confirmar = false">
                                NÃO
                              </button>
                            </div>
                          </div>
                      </div>
                      <!-- CARREGANDO -->
                      <div v-show="carregando">
                          <div class="col-md-12">
                            <p class="text-center">
                              <img src="img/enviando-emails.gif" alt="Enviando Emails" class="img-enviando"><br>
                              Enviando E-mails, <span class="text-success">Aguarde...</span>
                              <br><br>
                              <span class="text-danger">Atenção, não atualize, nem saia da página!</span>
                            </p>
                          </div>
                      </div>
                      <!-- ENVIADO -->
                      <div v-if="enviado">
                          <br>
                          <div class="col-md-12">
                             <div v-html="msg"></div>
                          </div>
                      </div>
                  </div>
              </div>
        </div>
      </div>
      <!-- {{email}} -->
  </div>
</template>
<script>

import { quillEditor } from 'vue-quill-editor'

export default {

  name: "email-coletivo",

  components: {
    quillEditor
  },

  data() {
    return {
        editorOption: {}, //do editor de texto
        confirmar: false,
        enviarEmailMassa : false,
        carregando: false,
        enviado: false,
        msg : '',
        mostrarMsgValidar: false,
        email: {
                 cod_id: null, todos: false,
                 pagantes: false,
                 solic_plano: false, prox_venc: false,
                 vencidos: false, gratis: false,
                 nao_tem_pacientes: false,
                 assunto: '', corpo_email: '', teste: false
               }

    }
  },

  methods: {
    //abrir componente enviar email
    abrirEnviarEmail() {
        this.email.cod_id = null
        this.email.todos = false
        this.email.pagantes = false
        this.email.solic_plano = false
        this.email.prox_venc = false
        this.email.vencidos = false
        this.email.gratis = false
        this.email.nao_tem_pacientes = false
        this.email.assunto = ''
        this.email.corpo_email = ''
        this.email.teste = false
        this.carregando = false
        this.confirmar = false
        this.enviado = false
        this.msg = 'ok'
        this.enviarEmailMassa = true
    },

    //clicar no botão enviar
    enviarEmail(){

          this.carregando = true
          axios.post('api/email-coletivo', this.email).then(({data}) => {
            this.msg = data
            this.carregando = false
            this.enviado = true
          }).catch((err) => {
            this.carregando = false
            this.msg = "<h4 class=\"text-danger\">Erro ao tentar enviar, atualize a página ou tente novamente.</h4>"
          })
    }

  },

  computed:{
      btnEnviar(){
          if (!this.email.cod_id) {
             return true
          }
          if (!this.email.assunto) {
            return true
          }
          if (!this.email.corpo_email) {
            return true
          }
          if (this.email.todos == false && this.email.pagantes == false && this.email.solic_plano == false
              && this.email.prox_venc == false && this.email.vencidos == false && this.email.gratis == false
              &&  this.email.nao_tem_pacientes == false &&  this.email.teste == false) {
              return true
          }
      },

      classTodos(){
         if (this.email.todos == true) {
            return 'text-danger'
         }
      },
      classPagantes(){
         if (this.email.pagantes == true) {
            return 'text-danger'
         }
      },
      classSolicitaram(){
         if (this.email.solic_plano == true) {
            return 'text-danger'
         }
      },
      classProxVenc(){
         if (this.email.prox_venc == true) {
            return 'text-danger'
         }
      },
      classVencidos(){
         if (this.email.vencidos == true) {
            return 'text-danger'
         }
      },
      classGratis(){
         if (this.email.gratis == true) {
            return 'text-danger'
         }
      },
      classNaoTemPac(){
         if (this.email.nao_tem_pacientes == true) {
            return 'text-danger'
         }
      },
      classTeste(){
         if (this.email.teste == true) {
            return 'text-danger'
         }
      }
  }
}
</script>
<style lang="scss" scoped>
.img-enviando{
    width: 250px;
    // height:
}
</style>
